import $ from 'jquery';
import app from './app';
// ---------------------------------------------------------
// Custom Functions for Front-End
// ---------------------------------------------------------
import 'swiper/css/swiper.css';
import './vendors/jquery.fancybox.css';
import Swiper from 'swiper/js/swiper.js';
import './vendors/cCalendar';
import './vendors/svgxuse';
import './vendors/jquery.fancybox';
import PerfectScrollbar from 'perfect-scrollbar';

var body = $("body");
var userAgent = window.navigator.userAgent;
var appVersion = window.navigator.appVersion;

// ユーザーエージェント判定 & bodyClass付与
// iPhoneかiPodかiPadなら、.iosStyleをbodyに付与
if ((userAgent.indexOf("iPhone") > 0) ||  (userAgent.indexOf("Android") > 0)) {
  body.addClass("mobileStyle");
}

function scheduleTabClick(e) {
  e.currentTarget._scheduleTabs.forEach(_scheduleTab => {
    if (_scheduleTab.classList.contains('current')) {
      _scheduleTab.classList.remove('current');
    }
  });
  this.classList.add('current');
  let _state = this.getAttribute('href'),
    _schedule = document.getElementById('cSchedule');
  _state === 'list' ? _schedule.classList.add('list') : _schedule.classList.remove('list');
  e.preventDefault();
}

function initScheduleTab() {
  let _scheduleTabs = document.querySelectorAll('.jsScheduleTab');
  if (_scheduleTabs.length) {
    _scheduleTabs.forEach(_scheduleTab => {
      _scheduleTab.addEventListener('click', scheduleTabClick);
      _scheduleTab._scheduleTabs = _scheduleTabs;
    });
  }
}

function activeScheduleList() {
  if (window.innerWidth <= 768) {
    var _schedule = document.getElementById('cSchedule');
    if (_schedule != null) {
      _schedule.classList.add('list');
    }
  }
}

function menuList() {
  var _btnHamburger = document.getElementById('btnHamburger');
  var _jsHeaderMenu = document.getElementById('jsHeaderMenu');
  var _idOverlay2 = document.getElementById('overlay2');

  if (_btnHamburger) {
    _btnHamburger.addEventListener('click', function(e) {
      this.classList.toggle('active');
      _jsHeaderMenu.classList.toggle('show');
      _idOverlay2.classList.toggle('active');
    });
  }

  if (_idOverlay2) {
    _idOverlay2.addEventListener('click', function(e) {
      if (_btnHamburger.matches('.active')) {
        _btnHamburger.click();
      }
    });
  }
}

function initAnchor() {
  var bodyEl = document.getElementsByTagName('body'),
    hash = window.location.hash,
    headerTop = 0;
  if (bodyEl[0].classList.contains('lTc')) {
    headerTop = 70;
    if (window.innerWidth < 769) {
      headerTop = 55;
    }
  } else if (bodyEl[0].classList.contains('lArt')) {
    headerTop = 130;
    if (window.innerWidth < 769) {
      headerTop = 55;
    }
  } else if (bodyEl[0].classList.contains('lArtSupport')) {
    headerTop = 152;
    if (window.innerWidth < 769) {
      headerTop = 55;
    }
  } else {
    if ($(window).width() < 769) {
      headerTop = $('.hTop').outerHeight();
    } else {
      headerTop = $('.hNav').outerHeight();
    }
  }
  if (hash) {
    var offsetTop = $(hash).offset().top;
    $('html, body').animate({
      scrollTop: 0
    }, 0);
    setTimeout(function() {
      $('html, body').animate({
        scrollTop: offsetTop - headerTop
      }, 1000);
    }, 250);
  }
}

function initNavSp() {
  if ($(window).width() > 768) {
    if ($(window).scrollTop() > $('.hTop').innerHeight()) {
      $('.hNav').addClass('fixNav');
      $('#wrapper').addClass('pdTop');
    } else {
      $('.hNav').removeClass('fixNav')
      $('#wrapper').removeClass('pdTop');
    }
  } else {
    $('.hNav').removeClass('fixNav')
    $('#wrapper').removeClass('pdTop');
  }
}

let stickyBnrEl = document.getElementById('jsStickyBnr');
function stickyBnrScroll(stickyBnrEl, state) {
  if(state) {
    stickyBnrEl.classList.add('sticky');
  }
  else {
    stickyBnrEl.classList.remove('sticky');
  }
}

function initPageToTop() {
  if ($('body').hasClass('lTc')) {
    if ($('.brandImgBg').offset().top > ($(window).scrollTop() + $(window).height()) && $('.fixNav').length) {
      $('.pageToTop').addClass('show');
    } else {
      $('.pageToTop').removeClass('show');
    }
  } else {
    if ($(window).scrollTop() > 20) {
      if(window.innerWidth > 768) {
        stickyBnrScroll(stickyBnrEl, true);
      }
      $('.pageToTop').addClass('show');
    } else {
      if(window.innerWidth > 768) {
        stickyBnrScroll(stickyBnrEl, false);
      }
      $('.pageToTop').removeClass('show');
    }
  }
}

$('.pageToTop').on('click', function() {
  $('html, body').animate({
    scrollTop: 0
  });
  return false;
});

function ScrollSticky(){
  let jsTagList = document.getElementById('jsTagList');
  if (!jsTagList) return;
  let tagListBlock = document.getElementById('tagListBlock');
  let topEle = tagListBlock.offsetTop;
  let scrollTop =  window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
  if(scrollTop > topEle){
    jsTagList.classList.add('active');
  } else {
    jsTagList.classList.remove('active');
  }
}

function anchor2(){
  let anchorEles = document.querySelectorAll('.anchor2');
  let anchorLength = anchorEles.length;
  for(i = 0; i < anchorLength; i++){
    anchorEles[i].addEventListener('click', function(e){
      let tagListBlock = document.getElementById('tagListBlock');
      let tagListBlockHeight = tagListBlock.offsetHeight ;
      let idEle = this.getAttribute('href').slice(1);
      let blockEle = document.getElementById(idEle);
      let offsetTop = blockEle.offsetTop - tagListBlockHeight;
      var ie = /msie|Trident.*rv[ :]*11\./gi.test(window.navigator.userAgent);
      if(ie){
        blockEle.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        });
      } else {
        e.preventDefault();
        window.scroll({
          top: offsetTop,
          left: 0,
          behavior: 'smooth'
        });
      }
    });
  }
}

function setHeightLinkEvent() {
  const block = document.querySelector('.jsLinkEvent');
  if(block){
    const box = block?.querySelector('.boxLinkEvent');
    block.style.height = box.offsetHeight + 'px';
  }
}

function stickyLinkEvent() {
  const nav = document.querySelector('.hNav');
  const block = document.querySelector('.jsLinkEvent');
  const box = block?.querySelector('.boxLinkEvent');
  const header = document.getElementById('header');
  let navHeight = 0;
  if(nav){
    navHeight = nav.offsetHeight;
  }
  if(window.innerWidth < 769){
    navHeight = header.offsetHeight;
  }
  if(block){
    let scroll = window.pageYOffset;
    let top = block.offsetTop;
    if(scroll > top - navHeight){
      box.classList.add('sticky');
      box.style.top = navHeight + 'px';
    } else {
      box.classList.remove('sticky')
    }
  }
}

//load
window.addEventListener('load', function(e) {
  initScheduleTab();
  activeScheduleList();
  hideOverlay();
  menuList();
  initAnchor();
  initNavSp();
  initPageToTop();
  anchor2();
  setHeightLinkEvent();

  $('[data-fancybox').fancybox({
    baseClass: 'fbGallery',
    smallBtn: true,
    toolbar: false,
    hash: false,
    infobar: false,
    animationEffect: 'fade',
    btnTpl: {
      smallBtn: '<button data-fancybox-close="" class="fancybox-button fancybox-button--close" title="Close"><svg class="icon"><use xlink:href="/assets/img/svg/symbol-defs.svg#i-close" /></svg>CLOSE</button>',
      arrowLeft: '<button data-fancybox-prev class="fancybox-button fancybox-button--arrow_left" title="{{PREV}}"><svg class="icon"><use xlink:href="/assets/img/svg/symbol-defs.svg#i-arrow-left2" /></svg></button>',
      arrowRight: '<button data-fancybox-next class="fancybox-button fancybox-button--arrow_right" title="{{NEXT}}"><svg class="icon"><use xlink:href="/assets/img/svg/symbol-defs.svg#i-arrow-right2" /></svg></button>',
    },
  });
});

//resize
window.addEventListener('resize', function() {
  activeScheduleList();
});

//sroll
window.addEventListener('scroll', function() {
  initNavSp();
  initPageToTop();
  ScrollSticky();
  stickyLinkEvent();
});

function hideOverlay() {
  let _overlay = document.getElementById('overlay');
  _overlay.addEventListener('click', handleClickOverlay);

}

function handleClickOverlay(e) {
  let _liElms = document.querySelectorAll('.hNav li');
  let _spanElms = document.querySelectorAll('.hNav li span');
  let _btnMenu = document.getElementById('btnMenu');
  let _hNav = document.getElementsByClassName('hNav');
  if (_liElms.length) {
    _liElms.forEach(_liElm => {
      _liElm.classList.remove('active');
    });
  }
  if (_spanElms.length) {
    _spanElms.forEach(_spanElm => {
      _spanElm.classList.remove('active');
    });
  }
  _hNav[0].classList.remove('show');
  _btnMenu.classList.remove('active');
  let cls = ["active", "active01"];
  e.target.classList.remove(...cls);
}

$(document).ready(function() {
  // ==============================================================
  // Active Menu
  // ==============================================================
  $('#btnMenu').click(function() {
    $(this).toggleClass('active');
    $(this).parents('.hTop').next('.hNav').toggleClass('show');
    $(this).parents('body').find('#overlay').toggleClass('active')
  });

  // check font
  function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    var expires = 'expires=' + d.toGMTString();
    document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
  }

  function getCookie(cname) {
    var name = cname + '=';
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return '';
  }

  function checkFont() {
    var fontSize = getCookie('font-size');
    if (fontSize != '' && fontSize != undefined) {
      $('html').css({
        'font-size': fontSize
      });
      $('.jsFontSize a').removeClass('active');
      $('.jsFontSize a').each(function() {
        var $el = $(this);
        if ($el.data('font') == fontSize) {
          $el.addClass('active');
        }
      });
      if (fontSize != '10px') {
        $('body').addClass('zoom');
        setTimeout(function() {
          if ($.fn.matchHeight != undefined) {
            $.fn.matchHeight._update();
          }
        }, 250);
      } else {
        $('body').removeClass('zoom');
      }
    } else {
      setCookie('font-size', '10px', 30);
      $('html').css({
        'font-size': '10px'
      });
      $('body').removeClass('zoom');
    }
  }

  checkFont();

  $('.jsFontSize a').on('click', function(e) {
    var $el = $(this),
      fontSize = $el.data('font');
    $el.parents('.jsFontSize').find('a').removeClass('active');
    $el.addClass('active');
    $('html').css({
      'font-size': fontSize
    });
    if (fontSize != '10px') {
      $('body').addClass('zoom');
    } else {
      $('body').removeClass('zoom');
    }
    setCookie('font-size', fontSize, 30);
    e.preventDefault();
  });

  $(".jsTab .tabTitle a").click(function(e) {
    e.preventDefault();
    var elm = $(this).attr('href').split("#")[1];
    var tabActive = $(this);
    if (!tabActive.parent("li").hasClass("active")) {
      tabActive.parent("li")
        .siblings()
        .removeClass("active");
      tabActive.parent("li").addClass("active");
      tabActive.parents(".tabTitle")
        .siblings('.tabContent')
        .children(".tabBox")
        .hide();
      $(this.hash).fadeIn();
      if ($(".tabTitle").hasClass("active")) {
        $(".tabTitle").slideUp().removeClass("active");
        $(".tabAcive").removeClass("active").children().text($(this).text());
      }
    }
    return false;
  });
  $(".spListTab .tabAcive").click(function(e) {
    if ($(".tabTitle").length) {
      $(".tabTitle").slideToggle().toggleClass("active");
      $(this).toggleClass("active");
    }
  });

  function carouselKeyv() {
    if ($('.jsKeyvCarousel').length) {
      var jsCarousel01 = new Swiper('.jsKeyvCarousel', {
        slidesPerView: 1,
        loop: true,
        autoHeight: false,
        speed: 1000,
        pagination: {
          el: '.jsKeyvCarousel .swiper-pagination',
          clickable: true,
        },
        navigation: {
          nextEl: '#keyv-button-next',
          prevEl: '#keyv-button-prev',
        },
        autoplay: {
          delay: 5000,
          disableOnInteraction: false
        },
        on: {
          init: function() {
            $('.jsKeyvCarousel .autoControl').find('.swiper-button-control').addClass('show');
          },
        },
      });
      $('.jsKeyvCarousel .swiper-button-pause').on('click', function() {
        var elm = $(this);
        if (elm.hasClass('swiper-button-play')) {
          jsCarousel01.autoplay.start();
          elm.removeClass('swiper-button-play');
        } else {
          jsCarousel01.autoplay.stop();
          elm.addClass('swiper-button-play');
        }
      });
    }
  }
  carouselKeyv();
  let jsCarousel02; 
  function initCarousel01() {
    function  checkActive (){
      const index = jsCarousel02.realIndex;
      const pagiList = $('.jsCarousel02 .swiper-pagination-bullet');
      pagiList.removeClass('swiper-pagination-bullet-active');
      pagiList[index - 1 < 0 ? realLength - 1 : index - 1].classList.add('swiper-pagination-bullet-active');
    }
    let carousel = document.querySelector('.jsCarousel02');
    if (!carousel) return;
    let swiperContainer = document.querySelector('.jsCarousel02 .swiper-container');
    let slideCount = swiperContainer.querySelectorAll('.swiper-slide:not(.swiper-slide-duplicate)').length;
    let windowWidth = window.innerWidth;
    if ((windowWidth < 769 && slideCount < 2) || (windowWidth >= 769 && slideCount < 4)) {
      if (swiperContainer.swiper) {
        swiperContainer.swiper.destroy(true, true);
        document.querySelector('.jsCarousel02 .swiper-button-play')?.classList.remove('swiper-button-play');
      }
      carousel.classList.add('swiper-not-init');
      return;
    } else {
      carousel.classList.remove('swiper-not-init');
    }
    if (!swiperContainer.swiper) {
      jsCarousel02 = new Swiper('.jsCarousel02 .swiper-container', {
        slidesPerView: 1.26,
        spaceBetween: 25,
        loop: true,
        speed: 1000,
        centeredSlides: true,
        pagination: {
          el: '.jsCarousel02 .swiper-pagination',
          clickable: true,
        },
        navigation: {
          nextEl: '#jsCarousel02-button-next',
          prevEl: '#jsCarousel02-button-prev',
        },
        autoplay: {
          delay: 5000,
          disableOnInteraction: false
        },
        breakpoints: {
          769: {
            spaceBetween: 60,
            slidesPerView: 3,
            centeredSlides: false,
          }
        },
        on: {
          init: function () {
            $('.jsCarousel02 .autoControl').find('.swiper-button-control').addClass('show');
          }
        }
      });
      $('.jsCarousel02 .swiper-button-pause').off('click').on('click', function() {
        var elm = $(this);
        if (elm.hasClass('swiper-button-play')) {
          jsCarousel02.autoplay.start();
          elm.removeClass('swiper-button-play');
        } else {
          jsCarousel02.autoplay.stop();
          elm.addClass('swiper-button-play');
        }
      });
    }
  }
  window.addEventListener("load", initCarousel01);
  window.addEventListener("resize", initCarousel01);

  function carousel02() {
    if ($('.jsCarousel03').length) {
      var jsCarousel03 = new Swiper('.jsCarousel03', {
        slidesPerView: 1,
        loop: true,
        speed: 1000,
        spaceBetween: 25,
        pagination: {
          el: '.jsCarousel03 .swiper-pagination',
          clickable: true
        },
        autoplay: {
          delay: 5000,
          disableOnInteraction: false
        },
        on: {
          init: function() {
            $('.jsCarousel03 .autoControl').find('.swiper-button-control').addClass('show');
          },
        },
      });
      $('.jsCarousel03 .swiper-button-pause').on('click', function() {
        var elm = $(this);
        if (elm.hasClass('swiper-button-play')) {
          jsCarousel03.autoplay.start();
          elm.removeClass('swiper-button-play');
        } else {
          jsCarousel03.autoplay.stop();
          elm.addClass('swiper-button-play');
        }
      });
    }
  }
  carousel02();

  function carousel03() {
    if ($('.jsCarousel04').length) {
      var jsCarousel04 = new Swiper('.jsCarousel04', {
        slidesPerView: 1,
        loop: true,
        effect: 'fade',
        speed: 1000,
        spaceBetween: 25,
        autoHeight: false,
        pagination: {
          el: '.jsCarousel04 .swiper-pagination',
          clickable: true
        },
        autoplay: {
          delay: 5000,
          disableOnInteraction: false
        },
        breakpoints: {
          769: {

          }
        },
        on: {
          init: function() {
            $('.jsCarousel04 .autoControl').find('.swiper-button-control').addClass('show');
          },
        },
      });
      $('.jsCarousel04 .swiper-button-pause').on('click', function() {
        var elm = $(this);
        if (elm.hasClass('swiper-button-play')) {
          jsCarousel04.autoplay.start();
          elm.removeClass('swiper-button-play');
        } else {
          jsCarousel04.autoplay.stop();
          elm.addClass('swiper-button-play');
        }
      });
    }
  }
  carousel03();

  function carousel04() {
    if ($('.jsCarousel05 .item').length > 1) {
      var jsCarousel05 = new Swiper('.jsCarousel05', {
        slidesPerView: 1,
        loop: true,
        speed: 1000,
        autoplay: {
          delay: 4000,
          disableOnInteraction: false
        },
        effect: 'fade',
        fadeEffect: {
          crossFade: true
        },
      });
    }
  }
  carousel04();

  function carouselFourItem() {
    if ($('.jsCarouselFourItem').length) {
      var jsCarouselFourItem = new Swiper('.jsCarouselFourItem', {
        slidesPerView: 1.26,
        spaceBetween: 25,
        loop: true,
        speed: 1000,
        pagination: false,
        pagination: {
          el: '.jsCarouselFourItem .swiper-pagination',
          clickable: true
        },
        navigation: {
          nextEl: '.jsCarouselFourItem' + '~  .swiper-btn-next',
          prevEl: '.jsCarouselFourItem' + '~  .swiper-btn-prev',
        },
        centeredSlides: true,
        autoplay: {
          delay: 5000,
          disableOnInteraction: false
        },
        breakpoints: {
          769: {
            spaceBetween: 30,
            slidesPerView: 4,
            centeredSlides: false,
          }
        },
        on: {
          init: function() {
            $('.jsCarouselFourItem .autoControl').find('.swiper-button-control').addClass('show');
          },
        },
      });
      $('.jsCarouselFourItem .swiper-button-pause').on('click', function() {
        var elm = $(this);
        if (elm.hasClass('swiper-button-play')) {
          jsCarouselFourItem.autoplay.start();
          elm.removeClass('swiper-button-play');
        } else {
          jsCarouselFourItem.autoplay.stop();
          elm.addClass('swiper-button-play');
        }
      });
    }
  }
  carouselFourItem();

  function carouselKeyv01() {
    if ($('.jsKeyvCarousel01').length) {
      var jsCarousel01 = new Swiper('.jsKeyvCarousel01', {
        slidesPerView: 1.2,
        loop: true,
        autoHeight: true,
        speed: 8000,
        centeredSlides: true,
        autoplay: {
          delay: 0,
          disableOnInteraction: false
        },
        breakpoints: {
          769: {
            slidesPerView: 2.1,
          }
        },
      });
    }
  }
  carouselKeyv01();

  function carouselTour() {
    if ($('.jsTourCarousel').length) {
      var jsTourCarousel = new Swiper('.jsTourCarousel', {
        slidesPerView: 1,
        loop: true,
        speed: 1000,
        autoplay: {
          delay: 4000,
          disableOnInteraction: false
        },
        navigation: {
          nextEl: '#tour-btn-next',
          prevEl: '#tour-btn-prev',
        },
      });
    }
  }
  carouselTour();
  $('.jsFilter').on('click', function() {
    $(this).toggleClass('active').next().slideToggle();
  })
  if ($('.btnAddItemForm').length && window.location.pathname.search("/summer_orchestra/") != -1) {
    var count = $('.btnAddItemForm.plus').attr('data-count') - 1;
    $('.btnAddItemForm.plus').click(function() {
      count++;
      var x =
        "<li class='itemForm volunteer'>" +
        "<p class='itemTitle'>" +
        "<label class='title'>参加者" + (count + 2) + "</label><span class=\"icon\">必須</span> " +
        "</p>" +
        "<p class='itemContent'>" +
        "<label>お名前:</label>" +
        "<input name='orchestra[orchestra_user_name_child][" + count + "]' type='text' class='inputForm ' placeholder='お名前' id='orchestra[orchestra_user_name_child]_id" + count + "'>" +
        "<label>ふりがな:</label> " +
        "<input name='orchestra[orchestra_user_hiragana_child][" + count + "]' type='text' class='inputForm' placeholder='ふりがなを入力' id='orchestra[orchestra_user_hiragana_child]_id" + count + "'>" +
        "<label>学年:</label> " +
        "<select name='orchestra[orchestra_user_year_child][" + count + "]' class='inputForm' placeholder='学年' id='orchestra[orchestra_user_year_child]_id" + count + "'>" +
        "<option value=''>選択してください</option>" +
        "<option value='小学校低学年（１-3年）'>小学校低学年（１-3年）</option>" +
        "<option value='小学校高学年（4-６年）'>小学校高学年（4-６年）</option>" +
        "<option value='中学生'>中学生</option>" +
        "<option value='高校生'>高校生</option>" +
        "<option value='大人'>大人</option>" +
        "</select>" +
        "<span class='itemFormSeatMumber hidden '>" +
        "<label>コンサートの座席番号（※D、Eをお申込の場合のみご記入ください。）:</label>" +
        "<input name='orchestra[orchestra_user_concert_seat_child][" + count + "]' type='text' class='inputForm concertSeatNumber' placeholder='コンサートの座席番号' id='orchestra[orchestra_user_concert_seat_child]_id" + count + "'>" +
        "</span>" +
        "<span class='boxPlusItem mt20'><span class='btnAddItemForm minus'><em></em>参加者を削除する</span></span>" +
        "</p>"
      "</li>";
      $('.blockForm').append(x);
      if (count >= 2) {
        $(this).addClass('hidden');
        $('.itemForm.volunteer:last-child .btnAddItemForm.minus').addClass('mr0');
      }
      $('.selectProgram').trigger('change');
    });

    $('.blockForm').on('click','.btnAddItemForm.minus', function() {
      count--;
      if (count > 0) {
        $('.btnAddItemForm.plus').removeClass('hidden');
        $('.itemForm.volunteer:last-child .btnAddItemForm.minus').removeClass('mr0');
      }
      $(this).parents('.itemForm').remove();
      $('.volunteer').each(function(id) {
        $(this).find('.title').html('参加者' + (id + 2));
        $(this).find('input[name*=orchestra_user_name_child]').attr('name', 'orchestra[orchestra_user_name_child][' + id + ']');
        $(this).find('input[name*=orchestra_user_hiragana_child]').attr('name', 'orchestra[orchestra_user_hiragana_child][' + id + ']');
        $(this).find('select[name*=orchestra_user_year_child]').attr('name', 'orchestra[orchestra_user_year_child][' + id + ']');
        $(this).find('input[name*=orchestra_user_concert_seat_child]').attr('name', 'orchestra[orchestra_user_concert_seat_child][' + id + ']');
      });
    });
  }

  if($('.tblScroll').length){
    document.querySelectorAll('.tblScroll').forEach(function(item){
      new PerfectScrollbar(item, {
        suppressScrollY: true,
      });
    })
  }

  // js for translate function
  function initTranslate() {
    let checkChangeLang = getCookie('changeLanguage');
    let cookieLang = getCookie('stt_lang');
    if (checkChangeLang == "" || checkChangeLang == null) {
      let lang =  window.navigator.language || window.navigator.userLanguage || window.navigator.browserLanguage;
      if (cookieLang != "") {
        document.cookie = `stt_lang = ${lang}`;
      }
      if(lang.length > 2 && lang.indexOf('en') !== -1){
        lang = 'en';
      }
      if (lang.length > 2 && lang.indexOf('vi') !== -1){
        lang = 'vi';
      }
      if ( lang.indexOf('en') === -1 && lang.indexOf('vi') === -1 && lang.indexOf('ko') === -1 && lang.indexOf('zh-CN') === -1 && lang.indexOf('zh-TW') === -1 && lang.indexOf('ja') === -1 ) {
        lang = 'ja';
      }
      $('select[name="language"]').val(lang);
      $('html').attr("lang", lang);
    } else {
      $('select[name="language"]').val(cookieLang);
      $('html').attr("lang", cookieLang);
    }
    $('select[name="language"]').on('change', function () {
      document.cookie = `stt_lang = ${this.value}`;
      document.cookie = 'changeLanguage=true';
      document.querySelector(`a[data-stt-changelang="${this.value}"]`).click();
      $('html').attr("lang", this.value);
      $('.langPull').attr('class', 'langPull active');
      if (this.value == 'en'){
        $('.btnLang').attr('class', 'btnLang en');
      } else if (this.value == 'ko'){
        $('.btnLang').attr('class', 'btnLang ko');
      } else if (this.value == 'vi'){
        $('.btnLang').attr('class', 'btnLang vi');
      } else if (this.value == 'zh-CN'){
        $('.btnLang').attr('class', 'btnLang cn');
      } else if (this.value == 'zh-TW'){
        $('.btnLang').attr('class', 'btnLang tw');
      } else {
        $('.btnLang').attr('class', 'btnLang ja');
      }
    });
  }
  initTranslate();
});

$('.iconLanguage').on('click', function(){
  $('.langPull').toggleClass('active');
});

var isIE11 = !!navigator.userAgent.match(/Trident.*rv\:11\./);
if (isIE11) {
  var $jsImgFit = document.querySelectorAll('.jsImgFit');
  var $jsImgFitLength = $jsImgFit.length;
  for (var i = 0; i < $jsImgFitLength; i++) {
    $jsImgFit[i].classList.add('isIE');
    var $linkImg = $jsImgFit[i].querySelector('img').src;
    $jsImgFit[i].style.backgroundImage = 'url(' + $linkImg + ')';
  }
}

$('.anchor').on('click', function(e) {
  var anchorLink = $(this).attr('href');
  var $heightNav = 0;
  if ($(window).width() < 769) {
    $heightNav = $('#header').innerHeight();
  } else {
    $heightNav = $('.hNav ').innerHeight();
  }
  if (anchorLink != '#') {
    var bodyEl = document.getElementsByTagName('body');
    if (bodyEl[0].classList.contains('lTc')) {
      $heightNav = 70;
      if (window.innerWidth < 769) {
        $heightNav = 55;
      }
    } else if (bodyEl[0].classList.contains('lArt')) {
      $heightNav = 130;
      if (window.innerWidth < 769) {
        $heightNav = 55;
      }
    } else if (bodyEl[0].classList.contains('lArtSupport')) {
      $heightNav = 152;
      if (window.innerWidth < 769) {
        $heightNav = 55;
      }
    }
    var offTop = $(anchorLink).offset().top - $heightNav;
    if($('.jsLinkEvent').length){
      offTop = offTop - $('.jsLinkEvent').innerHeight();
    }
    $('body, html').stop().animate({
      scrollTop: offTop
    }, 500);
    if (bodyEl[0].classList.contains('lTc') || bodyEl[0].classList.contains('lArt')) {
      let _btnMenu = document.getElementById('btnMenu');
      let _hNav = document.getElementsByClassName('hNav');
      let _overlay = document.getElementById('overlay');
      _btnMenu.classList.remove('active');
      _hNav[0].classList.remove('show');
      _overlay.classList.remove('active');
    }
  }
  return false;
});

window.addEventListener('load', function() {
  const iframeElement = document.querySelectorAll('.youtubeIframe');
  if(iframeElement){
    for(let i = 0; i < iframeElement.length; i++){
      const idYoutube = iframeElement[i].getAttribute('src').split('/').pop();
      const imgElement = document.createElement('img');
      const iconYoutube = document.createElement('img');
      imgElement.src = `https://i1.ytimg.com/vi/${idYoutube}/0.jpg`;
      imgElement.className = 'youtubeImage';
      iconYoutube.src = '/assets/img/svg/icon_youtube_01.svg';
      iconYoutube.className = 'youtubeIcon';
      iframeElement[i].insertAdjacentElement('afterend', imgElement);
      imgElement.insertAdjacentElement('afterend', iconYoutube);
    }
  }

  let lang = $('html').attr('lang');
  if(lang == 'en'){
    $('.btnLang').addClass('en');
  } else if (lang == 'vi') {
    $('.btnLang').addClass('vi');
  } else if (lang == 'ko') {
    $('.btnLang').addClass('ko');
  } else if (lang == 'zh-CN') {
    $('.btnLang').addClass('cn');
  } else if (lang == 'zh-TW') {
    $('.btnLang').addClass('tw');
  } else {
    $('.btnLang').addClass('ja');
  }
  checkTableInner();
});

$('.anchorSkipLink').on('click', function(e) {
  let anchorLink = $(this).attr('href');
  let $heightHeader = 0;
  if(window.innerWidth > 1300){
    $heightHeader = $('.hTop').innerHeight() + 50;
  } else {
    $heightHeader = $('.hTop').innerHeight() + 10;
  }
  if (anchorLink != '#') {
    var offTop = $(anchorLink).offset().top - $heightHeader;
    $('body, html').stop().animate({
      scrollTop: offTop
    }, 500);
  }
  return false;
});

$(window).on('scroll', function(e) {
  if($('.skipLink ').length) {
    if($(window).scrollTop() > 0){
      $('.skipLink ').removeClass('show');
    }
  }
  return false;
});

window.addEventListener('keyup', function(event) {
  if (window.innerWidth > 768) {
    let eleOverlay = $('#overlay');
    let ele = $(event.target);
    let eleJsToggle = $('.jsToggle');
    if (event.which === 9) {
      if( ele.hasClass('anchorSkipLink')) {
        ele.parent().addClass('show');
      }
      if( ele.hasClass('jsRemoveSkipLink')) {
        $('.skipLink').removeClass('show');
      }
      if( ele.hasClass('jsToggle')) {
        eleOverlay.addClass('active01');
        ele.addClass('active');
      }
      if( ele.hasClass('formControl')) {
        eleOverlay.removeClass('active01');
        eleJsToggle.removeClass('active');
      }
      if( ele.hasClass('btnLang')) {
        $('.langPull').addClass('active');
      }
      if( ele.hasClass('txtLang')) {
        $('.langPull').removeClass('active');
      }
      if( $('.jsCheckTabKey').length) {
        $('.jsCheckTabKey .swiper-slide-duplicate a').attr("tabindex","-1");
        $('.jsCheckTabKey .swiper-slide-prev a').attr("tabindex","-1");
      }
      if( ele.hasClass('jsNewsCheck') || ele.hasClass('jsAccordionCheck')) {
        ele.click();
      }
      ele.addClass('focusTabKey');
      $(ele).blur(function () {
        ele.removeClass('focusTabKey');
      });
    }
    if (event.which === 13) {
      if( ele.hasClass('jsEnterPress')) {
        ele.children('label').click();
      }
    }
  }
});

$('.skipLink a').on('click', function(){
  $('.skipLink').removeClass('show');
});

window.addEventListener('click', function(e) {
  $('.skipLink').removeClass('show');
  if ($(e.target).closest(".langBox").length === 0) {
    if($('.langPull').hasClass('active')){
      $('.langPull').removeClass('active');
    }
  }
});

function checkTableInner() {
  let tableEls = document.querySelectorAll('table');
  tableEls.forEach(tableEl => {
    let tableChildEls = tableEl.querySelectorAll('table');
    if(tableChildEls.length > 0) {
      tableEl.classList.add('tableBlock');
    }
  });
}
window.createTag = function (tag, attributes) {
  const el = document.createElement(tag);
  Object.entries(attributes).forEach(([key, value]) => {
    el[key] = value;
  });
  return el;
};

function replaceHashtag(arr, dataTxt) {
  arr.forEach((hashtag) => {
    let escapedTag = hashtag.tag.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    let regex = new RegExp(
      `[#＃]${escapedTag}(?=\\s|$|[「」×『』。、,・（）\\n()])`,
      "g"
    );
    dataTxt = dataTxt.replace(
      regex,
      `<a href="https://x.com/hashtag/${hashtag.tag}" target="_blank">#${hashtag.tag}</a>`
    );
  });
  return dataTxt;
}

function replaceMentions(dataTxt, mentions) {
    mentions.forEach(mention => {
      let escapedMention = mention.username.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      let mentionRegex = new RegExp(`@(${escapedMention})\\b`, 'g');
      dataTxt = dataTxt.replace(mentionRegex, `<a href="https://x.com/${mention.username}" target="_blank">@${mention.username}</a>`);
    });
    return dataTxt;
}

function checkLinkHasTweets(url, referencedTweets) {
    if(!referencedTweets) return false;
    const idTweet = url.split('/').pop();
    return referencedTweets.some(tweet => tweet.id === idTweet && tweet.type === "quoted");
}

function createMediaGrid(mediaDataArray) {
  const container = document.createElement("div");
  container.classList.add("xMedia");

  const mediaItems = mediaDataArray
    .filter((media) => media.type === "photo")
    .slice(0, 4);
  
  mediaItems.forEach((mediaData) => {
    const divImg = document.createElement("div");
    divImg.classList.add("xMediaImg");
    const img = window.createTag("img", { src: mediaData.url, alt: "Image" });
    divImg.appendChild(img);
    container.appendChild(divImg);
  });

  container.classList.add(`count-${mediaItems.length}`);

  return container;
}

function getDomainFromUrl(url) {
  try {
    let domain = new URL(url).hostname;
    return domain.replace(/^www\./, "");
  } catch (e) {
    return url;
  }
}

function createVideo(url) {
  const svg = `<svg viewBox="0 0 60 60" aria-hidden="true" class="r-uvuy5l r-cfp7ip"><g><circle cx="30" cy="30.4219" fill="#333333" opacity="0.6" r="30"></circle><path d="M22.2275 17.1971V43.6465L43.0304 30.4218L22.2275 17.1971Z" fill="white"></path></g></svg>`;
  const container = document.createElement("div");
  container.classList.add("xMedia");
  const divImg = document.createElement("div");
  divImg.classList.add("xMediaImg");
  const img = window.createTag("img", {
    src: url,
    alt: "Image",
  });
  divImg.appendChild(img);
  container.appendChild(divImg);
  const button = window.createTag("button", {
    innerHTML: svg,
    className: "xMediaPlay",
  });
  container.appendChild(button);
  return container;
}

function createUrlMeta(data, linkEl, og_image) {
  linkEl.href = data.url;
  linkEl.addEventListener("click", (e) => {
    e.stopPropagation();
    window.open(data.url);
  });
  const ogpImg = document.createElement("div");
  ogpImg.classList.add("xItemLink-img");
  const img = window.createTag("img", {
    src: og_image,
    alt: "Image",
  });
  ogpImg.appendChild(img);
  linkEl.appendChild(ogpImg);
  const ogpContent = document.createElement("div");
  ogpContent.classList.add("xItemLink-content");
  const ogpLink = document.createElement("span");
  ogpLink.classList.add("xItemLink-link");
  ogpLink.textContent = getDomainFromUrl(data.expanded_url);
  ogpContent.appendChild(ogpLink);
  const ogpTitle = document.createElement("div");
  ogpTitle.classList.add("xItemLink-title");
  const ogpTitleContent = document.createElement("span");
  ogpTitleContent.textContent = data.title;
  ogpTitle.appendChild(ogpTitleContent);
  ogpContent.appendChild(ogpTitle);
  const ogpDescription = document.createElement("span");
  ogpDescription.classList.add("xItemLink-des");
  ogpDescription.textContent = data.description;
  ogpContent.appendChild(ogpDescription);
  linkEl.appendChild(ogpContent);
}

function render(data, feedEl, site) {
  let xTemplate = document.getElementById("jsXTemplate"),
    el = xTemplate.content.cloneNode(true);
  if (el) {
    let itemEl = el.querySelector(".jsItem"),
      likeEl = el.querySelector(".jsLike"),
      commentEl = el.querySelector(".jsComment"),
      dateEl = el.querySelector(".jsDate"),
      desEl = el.querySelector(".jsDes"),
      imgEl = el.querySelector(".jsImg"),
      linkEl = el.querySelector(".jsLink");
    itemEl.dataset.href = "https://x.com/kaatjp/status/" + data.id;
    itemEl.addEventListener("click", (e) => {
      if (!e.target.closest(".jsDes a")) {
        window.open(itemEl.dataset.href);
      }
    });
    if (desEl) {
      desEl.querySelectorAll("a").forEach((anchor) => {
        anchor.addEventListener("click", (e) => {
          e.stopPropagation();
        });
      });
    }
    if (likeEl) {
      likeEl.dataset.txt = data.public_metrics.like_count;
    }
    if (commentEl) {
      commentEl.dataset.txt = data.public_metrics.reply_count;
    }
    if (dateEl) {
      dateEl.textContent = new Date(data.created_at).toLocaleDateString(
        "en-US",
        { month: "short", day: "numeric", year: "numeric" }
      );
    }
    if (desEl) {
      let dataTxt = data.text;
      if (data.note_tweet) {
        dataTxt = data.note_tweet.text;
        if (data.note_tweet.entities.urls) {
          const links = dataTxt.match(/https:\/\/\S+/g);
          data.note_tweet.entities.urls.forEach((url) => {
            if (links) {
              links.forEach((link) => {
                dataTxt = dataTxt.replace(
                  link,
                  `<a href="${url.expanded_url}" target="_blank">${url.display_url}</a>`
                );
              });
            }
          });
        }
        if (data.note_tweet.entities.hashtags) {
          dataTxt = replaceHashtag(data.note_tweet.entities.hashtags, dataTxt);
        }
      } else {
        if (data.entities.urls) {
          const links = dataTxt.match(/https:\/\/\S+/g);
          data.entities.urls.forEach((url) => {
            if (links) {
              links.forEach((link) => {
                const showURL =  !checkLinkHasTweets(url.expanded_url, data?.referenced_tweets);
                if (link.replace("…", "") == url.url && showURL) {
                  dataTxt = dataTxt.replace(
                    link,
                    `<a href="${url.expanded_url}" target="_blank">${url.display_url}</a>`
                  );
                } else {
                  dataTxt = dataTxt.replace(link, "");
                }
              });
            }
          });
        }
        if (data.entities.hashtags) {
          dataTxt = replaceHashtag(data.entities.hashtags, dataTxt);
        }
        if(data.entities.mentions){
          dataTxt = replaceMentions(dataTxt, data.entities.mentions);
        }
      }
      let urlMeta = {};
      if (
        data.entities &&
        Array.isArray(data.entities.urls) &&
        data.entities.urls.length > 0
      ) {
        urlMeta = data.entities.urls[0];
      }
      if (data.card_uri && urlMeta.images) {
        createUrlMeta(urlMeta, linkEl, data.entities.og_image);
      } else {
        linkEl.dataset.state = "disabled";
      }
      if (data.attachments && data.attachments.media_keys) {
        const mediaDataArray = data.attachments.media_keys
          .map((mediaKey) => media.find((m) => m.media_key === mediaKey))
          .filter((mediaData) => mediaData && mediaData.type === "photo");

        if (mediaDataArray.length > 0) {
          imgEl.appendChild(createMediaGrid(mediaDataArray));
        } else {
          data.attachments.media_keys.forEach((mediaKey) => {
            let mediaData = media.find((m) => m.media_key === mediaKey);
            
            if (mediaData) {
              if (mediaData.type === "video") {
                imgEl.appendChild(createVideo(mediaData.preview_image_url));
              } else if (
                mediaData.type === "animated_gif" &&
                mediaData.variants
              ) {
                console.log("GIF:", mediaData.variants[0].url);
              }
            }
          });
        }
      } else {
        if(data.entities.og_image) {
          if(!data.card_uri || !urlMeta.images) {
            const container = document.createElement("div");
            container.classList.add("xMedia");
            const divImg = document.createElement("div");
            divImg.classList.add("xMediaImg");
            const img = window.createTag("img", { src: data.entities.og_image, alt: "Image" });
            divImg.appendChild(img);
            container.appendChild(divImg);
            imgEl.appendChild(container);
          }else {
            imgEl.dataset.state = "disabled";
          }
        }else {
          imgEl.dataset.state = "disabled";
        }
      }
      desEl.innerHTML = dataTxt.replace(/\n/g, "<br>");
    }
  }
  feedEl.appendChild(el);
}

var media, tweets, users;
var site = "Kana_Ongakudo";
function displayFeed(data) {
  let datas = data.data,
    feedEl = document.getElementById("jsFeed");
  feedEl.innerHTML = "";
  media = data.includes?.media || [];
  tweets = data.includes?.tweets || [];
  users = data.includes?.users || [];
  if (datas && datas.length > 0) {
    datas.forEach((data) => {
      render(data, feedEl, site);
    });
  }
}

window.addEventListener("load", () => {
  const proxyUrl = `/twitter/timeline`;

  async function getFeed() {
    try {
      const response = await fetch(proxyUrl);
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      const data = await response.json();
      displayFeed(data);
    } catch (error) {
      console.error("Error fetching feed:", error);
    }
  }

  getFeed();
});